import { Component, OnInit, OnDestroy } from '@angular/core';
import { interval, timer, Observable, Subscription } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

import { StatisticsService } from '../../services/statistics.service';
import { EditionsService } from '../../services/editions.service';
import { EditionHeader } from '../../models/edition-header.model';
import { StatisticsHeader } from '../../models/statistics-header.model';
import { Statistics } from '../../models/statistics.model';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Moment } from 'moment';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-edition-statistics',
  templateUrl: './edition-statistics.component.html',
  styleUrls: ['./edition-statistics.component.scss']
})
export class EditionStatisticsComponent implements OnInit, OnDestroy {
  statisticsHeader: StatisticsHeader;
  editionHeader: EditionHeader;
  loading = false;
  subscription: Subscription;
  userSubscription: Subscription;
  constructor(
    private statisticsService: StatisticsService,
    private editionsService: EditionsService,
    private userService: UserService,
    public snackBar: MatSnackBar
  ) {
    this.userSubscription = userService.userSource$.subscribe(q => {
      this.ngOnInit();
    });
    this.subscription = statisticsService.statisticsSource$.subscribe(q => {
      this.refreshStatistics();
    });
  }

  ngOnInit() {
    if (this.userService.isLoggedIn) {
      this.showStatistics();
    } else {
      this.statisticsHeader = null;
      this.editionHeader = null;
    }
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.userSubscription.unsubscribe();
  }

  showStatistics(id?: string): void {
    this.loading = true;
    this.editionsService.getEditionHeader().subscribe(eh => {
      if (eh && eh.actual) {
        this.editionHeader = eh;
        this.statisticsService
          .getStatisticsHeader(eh.actual.id)
          .subscribe(r => {
            this.statisticsHeader = r;
            this.loading = false;
          }, e => (this.loading = false));
      } else {
        this.loading = false;
        this.snackBar.open('No se encontró edición para el día de trabajo actual', 'cerrar');
      }
    });
  }
  nextStatistics(): void {
    this.loading = true;
    this.editionsService
      .getEditionHeader(this.editionHeader.next.publishDates[0])
      .subscribe(eh => {
        this.editionHeader = eh;
        this.statisticsService
          .getStatisticsHeader(eh.actual.id)
          .subscribe(r => {
            this.changeValue(this.statisticsHeader.statistics, r.statistics);
            this.loading = false;
          }, e => (this.loading = false));
      });
  }

  prevStatistics(): void {
    this.loading = true;
    this.editionsService
      .getEditionHeader(this.editionHeader.previous.publishDates[0])
      .subscribe(eh => {
        this.editionHeader = eh;
        this.statisticsService
          .getStatisticsHeader(eh.actual.id)
          .subscribe(r => {
            this.changeValue(this.statisticsHeader.statistics, r.statistics);
            this.loading = false;
            // this.statisticsHeader = r;
          }, e => (this.loading = false));
      });
  }

  getStatistics(date: Moment) {
    this.loading = true;
    this.editionsService.getEditionHeader(date.toDate()).subscribe(eh => {
      if (eh && eh.actual) {
        this.editionHeader = eh;
        this.statisticsService
          .getStatisticsHeader(eh.actual.id)
          .subscribe(r => {
            // eslint-disable-next-line no-debugger
            debugger;
            this.changeValue(this.statisticsHeader.statistics, r.statistics);
            this.loading = false;
            // this.statisticsHeader = r;
          }, e => (this.loading = false));
      } else {
        this.loading = false;
        this.snackBar.open(
          `Para el día ${date.add(1, 'days').format('MMMM DD [de] YYYY')} no existe edición creada`,
          'Cerrar'
        );
      }
    });
  }

  refreshStatistics(): void {
    this.loading = true;
    this.statisticsService
      .getStatisticsHeader(this.editionHeader.actual.id)
      .subscribe(r => {
        this.changeValue(this.statisticsHeader.statistics, r.statistics);
        this.loading = false;
        // this.statisticsHeader = r;
      }, e => (this.loading = false));
  }

  onChangeDate($event: MatDatepickerInputEvent<Moment>) {
    const queryDate = $event.value.clone();
    this.getStatistics(queryDate.subtract(1, 'days'));
  }
  private changeValue(before: Statistics[], now: Statistics[]): void {
    for (const befItem of before) {
      for (const nowItem of now) {
        if (befItem.statusId === nowItem.statusId) {
          if (befItem.quantity !== nowItem.quantity) {
            const totalDelay = 1000;
            const difference = Math.abs(befItem.quantity - nowItem.quantity);
            let delta = 1;
            const delay = totalDelay / difference;
            const ii = interval(delay);
            const tt = ii.pipe(filter(val => val > difference));
            if (befItem.quantity > nowItem.quantity) {
              delta = -delta;
            }
            ii.pipe(takeUntil(tt)).subscribe(q => {
              if (befItem.quantity !== nowItem.quantity) {
                this.loading = true;
                befItem.quantity = befItem.quantity + delta;
              } else {
                this.loading = false;
              }
            });
          }
          break;
        }
      }
    }
  }
}
